export default class ProjectGroupTemplateDirectoryFilter {
  public onlyFolders: boolean = false
  public includeHidden: boolean = false
}
